import { create } from "zustand";

/**
 * Documents with an indexing run started from this session (LAR-252 async
 * indexing). The files views need to show a spinner for a healthy document the
 * moment its regeneration starts — before any revision flag changes — so the
 * reindex mutation records the accepted operation here and the status poller
 * picks it up. Cleared when the operation completes, fails, or is healed.
 */
interface IndexingOperationsState {
  /** documentId -> operationId */
  operations: Record<string, string>;
  start: (documentId: string, operationId: string) => void;
  clear: (documentId: string) => void;
}

export const useIndexingOperationsStore = create<IndexingOperationsState>(
  (set) => ({
    operations: {},
    start: (documentId, operationId) =>
      set((state) => ({
        operations: { ...state.operations, [documentId]: operationId },
      })),
    clear: (documentId) =>
      set((state) => {
        if (!(documentId in state.operations)) return state;
        const operations = { ...state.operations };
        delete operations[documentId];
        return { operations };
      }),
  })
);
